import React, { useState, useEffect } from 'react';
import './css/ListModelos.css';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { FiSearch } from 'react-icons/fi';
import { AiOutlinePlus, AiOutlineEdit } from 'react-icons/ai';
import { BsImage } from 'react-icons/bs';

const ListModelos = () => {
    const [modelos, setModelos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    let id_instituicao = localStorage.getItem('id_instituicao');

    function removerHTML(html) {
        return html.replace(/<[^>]+>/g, '');
      }
      

    useEffect(() => {
        const fetchModelos = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/modelos/instituicao/${id_instituicao}`,{
                    credentials: 'include',
                });
                if (!response.ok) throw new Error('Erro ao buscar os modelos.');
                const data = await response.json();
                setModelos(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchModelos();
        const interval = setInterval(() => {
            fetchModelos(); // Atualiza a cada 10 segundos
        }, 10000);
    
        return () => clearInterval(interval); 
    }, []);

    const filteredModelos = modelos.filter((modelo) =>
        modelo.nome_modelo.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <p>Carregando modelos...</p>;
    if (error) return <p>Erro: {error}</p>;

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="list-modelos-container">
                <h1 className="page-title">Modelos de Certificados</h1>
                <div className="header-section">
                    <div className="search-container">
                        <FiSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="Pesquisar por nome..."
                            className="search-bar"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <button className="add-button" onClick={() => navigate('/cadastrar-modelo')}>
                        <AiOutlinePlus /> Adicionar Novo Modelo
                    </button>
                </div>


                <div className="modelos-list">
                    {filteredModelos.map((modelo) => (
                        <div key={modelo.id_modelo} className="modelo-item">
                            <div className="foto-container">
                                {modelo.modelo_foto ? (
                                    <img
                                        src={`${process.env.REACT_APP_API_URL1}/${modelo.modelo_foto}`}
                                        alt={modelo.nome_modelo}
                                        className="modelo-foto"
                                    />
                                ) : (
                                    <div className="modelo-foto placeholder">
                                        <BsImage size={48} />
                                    </div>
                                )}
                            </div>
                            <div className="modelo-info">
                                <div className="modelo-header">
                                    <h3>{modelo.nome_modelo}</h3>
                                    <button
                                        className="edit-button"
                                        onClick={() => navigate(`/edit-modelo/${modelo.id_modelo}`)}
                                    >
                                        <AiOutlineEdit /> Editar
                                    </button>
                                </div>
                                <p>{removerHTML(modelo.texto)}</p>
                            </div>
                        </div>
                    ))}
                    {filteredModelos.length === 0 && (
                        <p className="no-results">Nenhum modelo encontrado.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ListModelos;
